import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f5641778&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
import style0 from "./Index.vue?vue&type=style&index=0&id=f5641778&prod&lang=scss&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=f5641778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5641778",
  null
  
)

export default component.exports